import React from 'react';
import styles from './VenueCard.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Image from '../../../components/Image/Image';
import { useTranslation } from 'react-i18next';
import { getCityCountry } from '../../../helpers/text';

const VenueCard = ({ venue }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const onRestaurantClick = () => {
    history.push({
      pathname: '/venue',
      search: `?showId=${venue.id}`,
    });
  };

  return (
    <div className={styles.card} onClick={() => onRestaurantClick()}>
      <div className='position-relative'>
        {venue.commission > 0 && (
          <div className={styles.commission}>
            <span>{t('winUntil')}</span>
            <div className={styles.commissionValue}>
              {parseInt(venue.commission)}
              <span>%</span>
            </div>
          </div>
        )}
        <Image src={venue.bannerImageUrl} alt={venue.name} size='MEDIUM' progressive={true} />
      </div>
      <div className='fw-600 font-small text-tertiary mt-2'>{venue.name}</div>
      <div className='font-smaller text-secondary'>{getCityCountry(venue.city.nameLong)}</div>
    </div>
  );
};

export default VenueCard;
